const status = [
  {
    name: 'entrySummary',
    label: 'Entry Summary',
    type: 'status',
    maxLength: undefined,
    placeholder: '',
    defaultValue: {
      value: 'Accepted',
      color: 'success', // Options are info | success | warning | error. Any other color will default to default text colour.
    },
    required: false,
    disabled: false,
    icon: undefined,
    readOnly: true,
  },
  {
    name: 'cargoRelease',
    label: 'Cargo Release',
    type: 'status',
    maxLength: undefined,
    placeholder: '',
    defaultValue: {
      value: 'Accepted',
      color: 'success',
    },
    required: false,
    disabled: false,
    icon: undefined,
    readOnly: true,
  },
  {
    name: 'releaseDate',
    label: 'Release Date',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: '1Usg',
    label: '1USG',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: 'Oct-06-2025 11:21',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const communication = [
  {
    name: 'communicationType',
    label: 'Communication Type',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'submit',
    label: 'Submit',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'status',
    label: 'Status',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'time',
    label: 'Time',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const communicationData = [
  {
    communicationType: 'Entry Summary',
    submit: 'Action: Modify [Oct-06-2025 11:26:59]',
    status: 'Accepted',
    time: 'Oct-06-2025 11:29',
  },
  {
    communicationType: 'Cargo Release SN',
    submit: '',
    status: 'Received',
    time: 'Oct-06-2025 11:21',
  },
  {
    communicationType: 'Cargo Release',
    submit: '',
    status: 'Accepted',
    time: 'Oct-06-2025 11:21',
  },
  {
    communicationType: 'Entry Summary',
    submit: 'Action: Add [Oct-06-2025 11:21:50]',
    status: 'Accepted',
    time: 'Oct-06-2025 11:21',
  },
];

const response = [
  {
    name: 'entryNumber',
    label: 'Entry Number',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'submissionType',
    label: 'Submission Type',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'responseType',
    label: 'Response Type',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'submittedTime',
    label: 'Submitted Time',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'receivedTime',
    label: 'Received Time',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'submittedBy',
    label: 'Submitted By',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'response',
    label: 'Response',
    type: 'response',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const responseData = [
  {
    entryNumber: 'SY2-12345678',
    submissionType: 'Entry Summary',
    responseType: 'Entry Summary',
    submittedTime: 'Oct-06-2025 11:21',
    receivedTime: 'Oct-06-2025 11:22',
    submittedBy: 'abc001',
    response: `
Type: SUMMRY, Position: 000001, REF ID: SY2 69990231 6999006      989
996: Request Accepted, 
      `,
  },
  {
    entryNumber: 'SY2-12345678',
    submissionType: 'Cargo Release SN',
    responseType: 'Cargo Release SN',
    submittedTime: 'Oct-06-2025 11:21',
    receivedTime: 'Oct-06-2025 11:22',
    submittedBy: 'abc001',
    response: `
SUMMARY, position:000001, REF ID: SY2 69990181 6999006
      `,
  },
  {
    entryNumber: 'SY2-12345678',
    submissionType: 'Cargo Release',
    responseType: 'Cargo Release',
    submittedTime: 'Oct-06-2025 11:21',
    receivedTime: 'Oct-06-2025 11:22',
    submittedBy: 'abc001',
    response: `
LINITM,  position:000001, REF ID: 001
27J: Census Warning, *CENSUS* OR-AGR CHARGES/VALUE
624: Fatally, EST DUTY/CALC'D DUTY MISMATCH - LINE
TARIFF, position:000002, REF ID: 6813810050
TARQTY, position:000002, REF ID: 000000500.00
442: Fatally, UOM MISMATCH
`,
  },
  {
    entryNumber: 'SY2-12345678',
    submissionType: 'Entry Summary',
    responseType: 'Entry Summary',
    submittedTime: 'Oct-06-2025 11:21',
    receivedTime: 'Oct-06-2025 11:22',
    submittedBy: 'abc001',
    response: `
LINITM,  position:000002, REF ID: 002
771: Fatally, TRFF ADJSTMNT HTS OR EXCLSN MISSING
TOTALS, position:000001, REF ID: SY2 69990181 6999006
722: Fatally, GRAND TOTAL DUTY NOT = SUM OF EST DUTY
998: REJECTED,Fatally,TRANSACTION DATA REJECTED
      `,
  },
];

const optionsMap = {};

export {
  status,
  communication,
  communicationData,
  response,
  responseData,
  optionsMap,
};